import { findIndex } from 'lodash';

const checkLabels = (label) => {
  switch (label) {
  case 'first_name':
    return 'First name';
  case 'last_name':
    return 'Last name';
  case 'phone':
  case 'whatsapp':
  case 'telegram':
  case 'website':
  case 'skype':
    return label.charAt(0).toUpperCase() + label.slice(1);
  case 'cpf':
    return 'CPF';
  default:
    return label;
  }
}

export const prepareFormData = (user, mode, fields, config) => {
  const data = [
    {
      label: 'Username',
      key: 'username',
      focus: true,
      needRef: mode,
      inputValue: '',
    },
    {
      label: 'Email',
      key: 'email',
      inputValue: '',
    },
  ];

  const password = {
    label: 'Password',
    key: 'password',
    tooltipText: 'Generate<br /> password',
    generate: true,
  };

  const payments = {
    label: 'Allowed payment methods',
    key: 'payment_methods',
    payments: true,
  };

  if (mode) {
    data[0].inputValue = user?.username;
    data[1].inputValue = user?.email;

    user?.user_details?.forEach((field) => {
      data.push({ label: checkLabels(field.name), key: field.name, inputValue: field.value || '' });
    });

    if (fields?.find((item) => item === 'cpf')) {
      data.push({ label: 'CPF', key: 'cpf', inputValue: user?.cpf || '' });
    }

    data.push({ ...payments, inputValue: user?.payment_methods });
  } else {
    fields.forEach((field) => {
      data.push({ label: checkLabels(field), key: field, inputValue: '' });
    });

    data.push({ ...password, inputValue: '' });
    data.push({ ...payments, inputValue: config?.payment_methods });
  }

  return {
    formFields: data,
    initValues: data.reduce((acc, item) => {
      acc[item.key] = item.inputValue;
      return acc;
    }, {}),
  };
};

export const checkIsChecked = (item, values) => {
  const index = findIndex(values.payment_methods, (el) => el.id === item.id);
  if (values.payment_methods.length) return values.payment_methods[index].checked;
};

export const handleChangeChechboxes = (item, values, setFieldValue) => {
  const checkedPayments = values.payment_methods;
  const checkedItems = checkedPayments.map((elem) => {
    if (elem.id === item.id) {
      elem.checked = !elem.checked;
    }

    return elem;
  });

  setFieldValue('payment_methods', checkedItems);
};
